import { Route, Routes } from "react-router-dom";
import Card from "./Card";
import RequestList from "./RequestList";

export default function Requests() {
	return (
		<Routes>
			<Route path="new/:type" element={<Card edit />} />
			<Route path=":id/edit" element={<Card edit />} />
			<Route path=":id" element={<Card />} />
			<Route path="/" element={<RequestList />} />
		</Routes>
	);
}